import { render } from "./onboard-screen.vue?vue&type=template&id=59191b95"
import script from "./onboard-screen.vue?vue&type=script&lang=js"
export * from "./onboard-screen.vue?vue&type=script&lang=js"

import "./onboard-screen.vue?vue&type=style&index=0&id=59191b95&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__